module.exports = __webpack_public_path__ + "static/media/banner-bronze@2x.e842df37.jpg";